export default "__VITE_ASSET__f479163f__"